import {useEffect, useState} from 'react';
import {getURLQueryFromObject} from '@netx/core-next/utils/url';
import {useComponentIsMounted} from '../hooks/useComponentIsMounted';
import {useConstCallback} from '../hooks/useConstCallback';
import {useDispatcher} from '../hooks/useDispatcher';
import {checkWatermarkAvailable} from './utils';

export type UseGenericImageWatermarkParams = {
	queryParams?: Record<string, number | string>;
};

export const useGenericImageWatermark = (
	options?: UseGenericImageWatermarkParams,
) => {
	const [watermarkSrc, setWatermarkSrc] = useState<string>();
	const {act} = useComponentIsMounted();

	// Anything that should be appended to the end of the url when requesting image
	const appendToSrc = getURLQueryFromObject(options?.queryParams);

	const handleWatermarkUpdate = useConstCallback(() => {
		checkWatermarkAvailable()
			.then((src) =>
				act(() => setWatermarkSrc(src ? `${src}${appendToSrc}` : undefined)),
			)
			.catch(() => act(() => setWatermarkSrc(undefined)));
	});

	// Load watermark image
	useEffect(() => {
		handleWatermarkUpdate();
	}, [appendToSrc]);

	// this is so hacky
	useDispatcher(
		'system:property:save',
		(prop: {label: string; value: string}) => {
			if (prop.label !== 'share.watermark.assetId') return;
			setTimeout(() => {
				handleWatermarkUpdate();
			}, 0);
		},
	);

	return {watermarkSrc};
};
